import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getRompslompMappings } from '../../../services/RompslompService';
import { payloadSentAs, useRompslompLabels } from '../../../utils/rompslompLabels';

// One lookup of the cached accounts and BTW codes per page load (display only; the payload itself is never touched).
let cached = null;

export function useRompslompLookup(active) {
    const [lookup, setLookup] = useState(cached);
    useEffect(() => {
        if (!active || cached) return undefined;
        let alive = true;
        (async () => {
            try {
                const res = await getRompslompMappings();
                const o = res.data.options;
                cached = { accounts: o.ledger_accounts || [], vat_types: o.vat_types || [] };
                if (alive) setLookup(cached);
            } catch (_) { /* the names are a convenience: the raw ids stay visible in the payload */ }
        })();
        return () => { alive = false; };
    }, [active]);
    return lookup;
}

// Under the exact payload: every category and BTW code in it, in the app language AND with the exact Dutch name and id that is sent.
export default function RompslompSentAs({ payload, lookup }) {
    const { t } = useTranslation();
    const labels = useRompslompLabels();
    if (!payload || !lookup) return null;
    const items = payloadSentAs(payload, lookup.accounts, lookup.vat_types, labels.language);
    if (items.length === 0) return null;
    return (
        <div className="small mt-2" data-testid="sent-as">
            <strong>{t('rompslomp.sentAs.title')}</strong>
            <ul className="mb-1 ps-3">
                {items.map((i) => (
                    <li key={`${i.kind}-${i.id}`}>
                        {t(`rompslomp.sentAs.${i.kind}`)}: {i.label}
                        {i.dutch ? ` - ${t('rompslomp.sentAs.sentAs', { dutch: i.dutch, id: i.id })}` : ` (id ${i.id})`}
                    </li>
                ))}
            </ul>
        </div>
    );
}
